import { Theme } from "@120wateraudit/waterworks";
import React, { useId, useState } from "react";
import type { DropdownProps } from "semantic-ui-react";
import { Dropdown as SemanticDropdown } from "semantic-ui-react";
import { ExportType } from "src/types/enums/ExportRequest";
import styled from "styled-components";

interface ExportDropdownProps {
  handleExport: (exportType: ExportType) => void;
  exportOptions: Array<{
    key: string;
    text: string;
    value: ExportType;
  }>;
}

const ExportDropdown: React.FC<ExportDropdownProps> = ({
  handleExport,
  exportOptions,
}) => {
  const searchInputId = useId().replace(/:/g, '');
  const [isOpen, setIsOpen] = useState(false);
  const menuId = `export-type-list-${searchInputId}`;
  const onExport = (exportType: ExportType): void => {
    handleExport(exportType);
  };

  return (
    <StyledDropdown
      button
      className="ui button"
      search
      searchInput={{ id: `export-type-dropdown-${searchInputId}`, 'aria-label': 'Export options' }}
      options={exportOptions.map((o) => ({ ...o, value: o.value }))}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      aria-haspopup="true"
      aria-expanded={isOpen}
      aria-controls={menuId}
      id={`export-type-dropdown-${searchInputId}`}
      onChange={(
        _e: React.SyntheticEvent<HTMLElement, Event>,
        data: DropdownProps,
      ) => {
        onExport(data.value as ExportType);
      }}
      text="Export"
      aria-label="Export"
    />
  );
};
const StyledDropdown = styled(SemanticDropdown)`
  background-color: ${Theme.palette.primary} !important;
  color: ${Theme.palette.primaryText} !important;
  font-weight: 600 !important;
`;

export default ExportDropdown;
